<div class="container">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top: 10px;">
      <div class="panel panel-default" id="panel4" style="margin-bottom: 0px !important;">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a>
              <b>View SLHR Matrix</b>
            </a>
          </h4>
        </div>
      </div>
      <div class="row" id="divTop" style="margin-bottom: 10px;">
        <div class="col-md-12 col-lg-12 col-sm-12">
          <div class="col-md-9 col-xs-9">
            <div id="ButtonsTab">
              <button id="btnGetResult" type="button" title="Get Result" class="btn btn-primary"
                      (click)="GetSearchAndExportResult('Search');">
                <span class="hidden-xs">Get Result</span>
              </button>
              <button id="btnReset" type="button" title="Reset" class="btn btn-primary" (click)="ResetResult();">
                <span>Reset</span>
              </button>
              <button id="btnExport" type="button" title="Export" (click)="GetSearchAndExportResult('Export');" class="btn btn-primary">
                <span class="hidden-xs">Export</span>
              </button>
              <button id="btnMarkRecordActive" type="button" title="Mark Record Active" (click)="MarkRecordInActiveAccessMatrix('Active');" class="btn btn-primary">
                <span class="hidden-xs">Mark Record Active</span>
              </button>
               <button id="btnMarkRecordInActive" type="button" title="Mark Record In Active" (click)="MarkRecordInActiveAccessMatrix('InActive');" class="btn btn-primary">
                <span class="hidden-xs">Mark Record In Active</span>
              </button>
              <button id="btnExit" type="button" title="Exit" class="btn btn-primary" (click)="onExit();">
                <span class="hidden-xs">Exit</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="accordion">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
              <b>Search Criteria &nbsp;&nbsp; (Click (+/-) to view the Search Parameters)</b>
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4">Employee Name</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                        <p-autoComplete [(ngModel)]="EmployeeList.Employee" [suggestions]="filteredEmployeeSingle" autocomplete="off"
                                        (completeMethod)="GetEmpSearch($event,false)" field="EmpFullName" [size]="30"
                                        placeholder="Enter Name for Search" [minLength]="3" aria-describedby="basic-addon3"
                                        name="Employee" (onClear)="OnClearSendUser()" (onSelect)="SetSelectedEmpGPN($event)"
                                        [forceSelection]="true" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top: 7px;">Service Line</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                         <mat-select [(ngModel)]="ViewAccessRecordList.ServiceLine" class="form-control"  placeholder="Please Select Service Line" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}">
                          <mat-option [value]="'All'">All</mat-option>
                          <mat-option *ngFor="let option of ServiceLineList" [value]="option.SL">
                          {{ option.SL }}
                        </mat-option>
                      </mat-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top:7px;">Competency</span>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <mat-select [(ngModel)]="ViewAccessRecordList.Competency" class="form-control"  placeholder="Please Select Competency" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}">
                        <mat-option [value]="'All'">All</mat-option>
                        <mat-option *ngFor="let option of CompetencyList" [value]="option.CompetencyCode">
                          {{ option.CompetencyName }}
                        </mat-option>
                      </mat-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4">MS</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                         <mat-select [(ngModel)]="ViewAccessRecordList.MargentSegment" class="form-control"  placeholder="Please Select MS" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}">
                          <mat-option [value]="'All'">All</mat-option>
                          <mat-option *ngFor="let option of MargentSegmentList" [value]="option.MarketSegment">
                          {{ option.MarketSegment }}
                        </mat-option>
                      </mat-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top: 7px;">Location</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                         <mat-select [(ngModel)]="ViewAccessRecordList.Location" class="form-control"  placeholder="Please Select Location" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}">
                        <mat-option  [value]="'All'">All</mat-option>
                        <mat-option *ngFor="let option of LocationList" [value]="option.Location">
                          {{ option.Location }}
                        </mat-option>
                      </mat-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top:7px;">Client Serving</span>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <mat-select [(ngModel)]="ViewAccessRecordList.ClientServingId" class="form-control"  placeholder="Please Select Client Serving" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}">
                        <mat-option *ngFor="let option of ClientServingList" [value]="option.KeyWordValue">
                          {{ option.KeyWordText }}
                        </mat-option>
                      </mat-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top: 7px;">Is Active</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                    <div class="col-md-8 col-sm-8">
                      <mat-radio-group [(ngModel)]="ViewAccessRecordList.IsActive">
                        <mat-radio-button  value="True">True</mat-radio-button>
                        <mat-radio-button  value="False">False</mat-radio-button>
                      </mat-radio-group>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="panel-group">
            <div class="panel panel-default" id="panel1">
              <div class="panel-heading d-flex align-items-center justify-content-between">
                <h4 class="panel-title">
                  <a>
                    <b>View Records</b>
                  </a>
                </h4>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-12" style="width: 100%;">
                    <table id="table1" class="dataTable table table-striped1">
                      <thead>
                        <tr>
                          <th></th>
                          <th [appSort]="ViewAccessMatrixRecordList" data-order="desc" data-name="EmpName" style="cursor: pointer;">Employee Name</th>
                          <th>Employee GPN</th>
                          <th>Service Line</th>
                          <th>Competency</th>
                          <th>Location</th>
                          <th>Market Segment</th>
                          <th>Client Serving</th>
                          <th>Is Active</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of ViewAccessMatrixRecordList; let i = index;">
                          <td>
                            <input type="checkbox" name="item{{item.ID}}" [(ngModel)]="ViewAccessMatrixRecordList[i].checked">
                          </td>
                          <td>
                            <a (click)="OnClickAccessMatrixRecord(item.IDEncrypt)" style="cursor: pointer;">{{item.EmployeeName}}</a>
                          </td>
                          <td>{{item.EmployeeGPN}}</td>
                          <td>{{item.ServiceLine}}</td>
                          <td>{{item.Competency}}</td>
                          <td>{{item.LocationText}}</td>
                          <td>{{item.MarketSegment}}</td>
                          <td>{{item.ClientServing}}</td>
                          <td>{{item.IsActive}}</td>
                        <tr *ngIf="ViewAccessMatrixRecordList==null || ViewAccessMatrixRecordList.length==0">
                          <td colspan="9" style="text-align: center;color: red;">Record not found.</td>
                        </tr>
                      </tbody>
                    </table>
                    <ul class="pagination" *ngIf='(ViewAccessMatrixRecordList?.length||0)>0'>
                      <li class="page-item">
                        <button class="page-link" (click)="firstPage()"
                                *ngIf="ViewAccessRecordList.currentPage > 1">
                          First
                        </button>
                      </li>
                      <li class="page-item">
                        <button class="page-link" (click)="PreviousPage()" *ngIf="this.ViewAccessRecordList.currentPage > 1">
                        </button>
                      </li>
                      <li *ngFor="let n of range(this.ViewAccessRecordList.TotalPageCount)" class="page-item">
                        <button class="page-link" (click)="setPage(n+1)" [innerHtml]="n+1">{{n+1}}</button>
                      </li>
                      <li class="page-item" *ngIf="this.ViewAccessRecordList.currentPage < this.ViewAccessRecordList.TotalPageCount">
                        <button class="page-link" (click)="NextPage()">>></button>
                      </li>
                      <li class="page-item" *ngIf="this.ViewAccessRecordList.currentPage < this.ViewAccessRecordList.TotalPageCount">
                        <button class="page-link" (click)="lastPage()">Last</button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="isLoading" class="overlay">
  <p-progressSpinner styleClass="spinner" [style]="{width: '100px', height: '100px'}"></p-progressSpinner>
</div>
